module.exports = __webpack_public_path__ + "img/分组 35.83c02539.png";